import { render } from "./MdOptgroup.vue?vue&type=template&id=9dac1090"
import script from "./MdOptgroup.vue?vue&type=script&lang=js"
export * from "./MdOptgroup.vue?vue&type=script&lang=js"

import "./MdOptgroup.vue?vue&type=style&index=0&id=9dac1090&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__